// angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding } from '@angular/core';

// services

import { UtilityService } from '@app/core/utility/utility.service';
import { BaseService } from '@core/base/base.service';
import { generateClassPrefix } from '@windmillcode/angular-wml-components-base';

// rxjs
import { Subject } from 'rxjs';

// misc

@Component({
  selector: 'overlay-loading',
  templateUrl: './overlay-loading.component.html',
  styleUrls: ['./overlay-loading.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush

})
export class OverlayLoadingComponent  {

  constructor(
    public cdref:ChangeDetectorRef,
    public utilService:UtilityService,

    public baseService:BaseService
  ) { }
  classPrefix = generateClassPrefix('OverlayLoading')
  @HostBinding('class') myClass: string = this.classPrefix(`View`);
  ngUnsub= new Subject<void>()

  ngOnInit(): void {
  }

  ngOnDestroy(){
    this.ngUnsub.next();
    this.ngUnsub.complete()
  }

}
